import { api } from '@/infra/api'
import type { ApiResponse } from '@/infra/types'
import type { OAuthProvider, OAuthRedirectResponse, SignupRequest, Token } from './schemas'

export const authApi = {
  async getOAuthRedirect(provider: OAuthProvider): Promise<OAuthRedirectResponse> {
    const { data } = await api.get<ApiResponse<OAuthRedirectResponse>>(
      `/api/v1/auth/oauth/redirect/${provider}`
    )
    if (!data.data) {
      throw new Error('No OAuth redirect data received')
    }
    return data.data
  },

  async handleOAuthCallback(
    provider: OAuthProvider,
    code: string,
    state: string,
    nonce?: string
  ): Promise<Token> {
    const { data } = await api.post<ApiResponse<Token>>(`/api/v1/auth/oauth/${provider}`, {
      code,
      state,
      nonce: nonce ?? null,
    })
    if (!data.data) {
      throw new Error('No token received')
    }
    return data.data
  },

  async signup(credentials: SignupRequest): Promise<Token> {
    const { data } = await api.post<ApiResponse<Token>>('/api/v1/auth/signup', credentials)
    if (!data.data) {
      throw new Error('No token received')
    }
    return data.data
  },
}
